import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { formatMoney } from '@/common/helpers'

// Types
import type { Props } from '@/components/ui/Money'

// Use
import useThemeClassName from '@/hooks/useThemeClassName'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'Money',
  props: {
    tag: { default: 'span' },
    money: { default: 0 },
    currency: { default: '₽' },
    addZeros: { type: Boolean, default: false },
    separator: { default: ',' },
    theme: {}
  },
  setup(__props: any) {

const props = __props

// Computed
const themeClassName = computed(() => useThemeClassName('ui-money', props.theme))
const price = computed<string>(() => {
  return `${formatMoney(Number(props.money), props.addZeros, props.separator,)} ${props.currency}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
    class: _normalizeClass(["ui-money", [themeClassName.value]]),
    innerHTML: price.value
  }, null, 8, ["class", "innerHTML"]))
}
}

})